import {
  getLocalStorage,
  removeLocalStorage,
  setLocalStorage,
} from '@/common/localStorages';
import { firebaseStorageMaxAge } from '../../firebase.config';

export const STORAGE_KEY = 'firebase_token';
export type TFCMStorage = { expiresAt: number; hash: string };
export type TFCMStorages = Record<string, TFCMStorage>;

export const setFCMTokenStorage = (userKey: string, fcmToken: string): void => {
  const expiresAt = Date.now() + firebaseStorageMaxAge * 1000;
  const hash = getFCMTokenHash(fcmToken);
  return setLocalStorage(STORAGE_KEY, { [userKey]: { expiresAt, hash } });
};

export const getFCMTokenStorage = (userKey: string): TFCMStorage => {
  return getLocalStorage(STORAGE_KEY)?.[userKey] || { expiresAt: 0, hash: '' };
};

export const removeFCMTokenStorage = () => {
  return removeLocalStorage(STORAGE_KEY);
};

export const shouldRemoveFCMTokenStorage = (userKey: string): boolean => {
  // * If firebase token exist in local storage but it doesn't belong to current user
  return !!getLocalStorage(STORAGE_KEY) && !getFCMTokenStorage(userKey)?.hash;
};

export const hasFreshExistingFCMTokenInStorage = (
  userKey: string,
  fcmToken: string
): boolean => {
  const { hash, expiresAt } = getFCMTokenStorage(userKey);
  const isFresh = expiresAt > Date.now();
  return isFresh && getFCMTokenHash(fcmToken) === hash;
};

export const getFCMTokenHash = (fcmToken: string) => {
  return fcmToken.slice(-16);
};
